import Layout from '@/layout';
var wecomRouter = {
  path: '/wecom',
  component: Layout,
  redirect: '/wecom/contact/list',
  name: 'Wecom',
  alwaysShow: true,
  meta: {
    title: '企微',
    icon: 'peoples'
  },
  children: [{
    path: 'contact/list',
    component: function component() {
      return import('@/views/wecom/contact/list/index');
    },
    name: 'WecomContactList',
    meta: {
      title: '客户列表',
      icon: ''
    }
  }, {
    path: 'contact/detail/:contactId',
    component: function component() {
      return import('@/views/wecom/contact/detail/index');
    },
    name: 'WecomContactDetail',
    hidden: true,
    meta: {
      title: '客户详情',
      activeMenu: '/wecom/contact/list'
    }
  }, {
    path: 'tag/list',
    component: function component() {
      return import('@/views/wecom/tag/list/index');
    },
    name: 'WecomTagList',
    meta: {
      title: '标签列表',
      icon: ''
    }
  }, {
    path: 'order/list',
    component: function component() {
      return import('@/views/wecom/order/list/index');
    },
    name: 'WecomOrderList',
    meta: {
      title: '订单列表',
      icon: ''
    }
  }, {
    path: 'order/detail/:orderNo',
    component: function component() {
      return import('@/views/wecom/order/detail/index');
    },
    name: 'WecomOrderDetail',
    hidden: true,
    meta: {
      title: '订单详情',
      activeMenu: '/wecom/order/list'
    }
  }]
};
export default wecomRouter;